import { useState } from 'react';
import { differenceInDays } from 'date-fns';
import gettext from '@sdk/lang/gettext';
import SlingTip from '@sdk/common/slingTip/SlingTip';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

const LEARN_MORE_URL =
  'https://support.getsling.com/en/articles/8723681-scheduling-pro-timesheet-tooltip';

type Props = {
  active: boolean;
};

export const TimesheetErrorTip = ({ active }: Props) => {
  if (!active) {
    return;
  }

  return <Inner />;
};

const Inner = () => {
  const CACHE_KEY = 'timesheetErrorTipLastDismissedAt';
  const lastDismissedAt = localStorage.getItem(CACHE_KEY);

  const handleDismiss = () => {
    localStorage.setItem(CACHE_KEY, Date());
    setIsVisible(false);
  };

  const handleLearnMore = () => {
    window.open(LEARN_MORE_URL, '_blank');
  };

  const [isVisible, setIsVisible] = useState(
    !lastDismissedAt || differenceInDays(new Date(), new Date(lastDismissedAt)) > 7
  );

  return (
    <SlingTip isVisible={isVisible} onDismiss={handleDismiss} onLearnMore={handleLearnMore}>
      <Text14 semiBold themeColor={ThemeColorType.white}>
        {gettext(
          "Some timesheets won't be synced to Toast as there is no equivalent for a position or an employee."
        )}
        <br />
        {gettext('Check the Source column for more details.')}
      </Text14>
    </SlingTip>
  );
};
